<div class="dialog-wrapper">
  <h1
    class="primary-brand-color col-lg-12 font-size-popup-title mt-4 mb-4"
    mat-dialog-title
  >
    {{ data.dialogTitle }}
  </h1>
  <div mat-dialog-content>
    <div class="row mr-0 ml-0 mb-2">
      <div class="col-md-12 pl-0">
        <div class="form-group d-lg-flex d-md-block mb-1">
          <p class="col-lg-12 col-md-12 col-sm-12 required">
            {{ data.dialogDiscription }}
          </p>
        </div>
      </div>
    </div>
    <div class="row mr-0 ml-0">
      <div class="col-md-12 pl-0">
        <div class="form-group d-lg-flex d-md-block">
          <label
            [class.col-lg-3]="
              ('admin.global.currentLanguage' | translate) === 'mk'
            "
            [class.col-lg-2]="
              ('admin.global.currentLanguage' | translate) !== 'mk'
            "
            class="col-md-12 col-sm-12 required"
            for="email"
            >{{ 'admin.global.email' | translate }}
          </label>
          <div
            [class.col-lg-9]="
              ('admin.global.currentLanguage' | translate) === 'mk'
            "
            [class.col-lg-10]="
              ('admin.global.currentLanguage' | translate) !== 'mk'
            "
            class="input-group col-md-12 col-sm-12"
          >
            <app-input-text
              [bare]="true"
              inputId="email"
              [placeholder]="'admin.global.email' | translate"
              autocomplete="email"
              [maxLength]="50"
              [autoFocus]="true"
              [value]="data.inviteeEmail"
              (inputEvent)="data.inviteeEmail = $any($event.target).value"
            ></app-input-text>
            <div class="invalid-feedback d-block">
              <span *ngIf="data?.inviteeEmail?.length > 50">{{
                'admin.global.field.maxLength' | translate: { maxLength: '50' }
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="float-right pr-3 pb-4 mt-4">
    <a
      type="link"
      class="primary-brand-color cursorPointer text-underline order-1"
      (click)="onNoClick()"
      >{{ 'admin.global.cancel' | translate }}</a
    >
    <app-button
      class="ml-4 order-2"
      variant="primary"
      classes="px-4"
      type="button"
      [disabled]="data?.inviteeEmail?.trim().length == 0"
      (click)="save()"
    >
      {{ 'admin.store.users.inviteUser.invitePrimaryButton' | translate }}
    </app-button>
  </div>
</div>
